import { render, staticRenderFns } from "./ReminderItem.vue?vue&type=template&id=7d2b297c"
import script from "./ReminderItem.vue?vue&type=script&lang=js"
export * from "./ReminderItem.vue?vue&type=script&lang=js"
import style0 from "./ReminderItem.vue?vue&type=style&index=0&id=7d2b297c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports